import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as Api from '@vi-iot/client';
import { Invitation } from '@vi-iot/client';

import { InvitationsActions } from '../invitations/invitations.actions';

import { NewInvitationActions } from './new-invitation.actions';

@Injectable()
export class NewInvitationEffects {
  createInvitation$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(NewInvitationActions.createInvitation),
      switchMap((action) =>
        this.api.createInvitation(action.request).pipe(
          map((response) =>
            NewInvitationActions.createInvitationSuccess({
              response,
              gatewaySerial: action.request.gatewaySerial,
            })
          ),
          catchError((error: { errorType?: string; message?: string; statusCode?: number }) =>
            of(NewInvitationActions.createInvitationError({ error }))
          )
        )
      )
    );
  });

  createInvitationSuccess$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(NewInvitationActions.createInvitationSuccess),
      map((action) =>
        InvitationsActions.addPendingInvitation({
          invitation: action?.response?.data || ({} as Invitation),
          gatewaySerial: action.gatewaySerial,
        })
      )
    );
  });

  constructor(private api: Api.InvitationsApi, private actions$: Actions) {}
}
